const marqueeSection = () => {
    const textMarquee = document.querySelector('[data-text-marquee]');
    if (textMarquee) {
        const cloneAndSroll = () => {
            var e = function (e) {
                var t, n;
                (this.element = e),
                    (this.list = this.element.getElementsByTagName('ul')[0]),
                    (this.items = this.list.children),
                    (this.paused = !1),
                    (this.clones = this.list.innerHTML),
                    (this.clonesNumber = 1),
                    (this.itemsLength = this.items.length),
                    (this.animationDuration = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--marquee-animation-duration'))),
                    i((t = this)),
                    s(t),
                    (n = t),
                    new IntersectionObserver(function (e) {
                        e[0].isIntersecting ? this.paused || this.element.classList.add('marquee--animate') : this.element.classList.remove('marquee--animate');
                    }.bind(n)).observe(n.element),
                    t.element.addEventListener('update-marquee', function (e) {
                        i(t), s(t);
                    }),
                    t.element.addEventListener('anim-marquee', function (e) {
                        (t.paused = !1), t.element.classList.remove('marquee--paused');
                    }),
                    t.element.addEventListener('pause-marquee', function (e) {
                        (t.paused = !0), t.element.classList.add('marquee--paused');
                    }),
                    t.element.classList.add('marquee--loaded');
            };
            function i(e) {
                for (var t, n, i = 0, s = 0; s < e.itemsLength; s++)
                    i += ((t = e.items[s]), void 0, (n = window.getComputedStyle(t)), parseFloat(n.marginRight) + parseFloat(n.marginLeft) + t.offsetWidth);
                i < window.innerWidth ? (e.clonesNumber = 2 * Math.ceil(window.innerWidth / i) - 1) : (e.clonesNumber = 1), (e.list.style.width = (e.clonesNumber + 1) * i + 'px');
            }
            function s(e) {
                e.list.innerHTML = e.clones;
                for (var t = 0; t < e.clonesNumber; t++)
                    e.list.insertAdjacentHTML('beforeend', e.clones);
                e.element.style.setProperty('--marquee-animation-duration', e.animationDuration * (e.clonesNumber + 1) + 's');
            }
            function t(s) {
                var e = document.getElementById(s.getAttribute('aria-controls'));
                if (e) {
                    var r = e.getElementsByClassName('text-marquee__container');
                    r.length < 1 && (r = [e]),
                        s.addEventListener('click', function (e) {
                            var t = 'true' == s.getAttribute('aria-pressed'), n = t ? 'anim-marquee' : 'pause-marquee';
                            t ? s.setAttribute('aria-pressed', 'false') : s.setAttribute('aria-pressed', 'true');
                            for (var i = 0; i < r.length; i++)
                                r[i].dispatchEvent(new CustomEvent(n));
                        });
                }
            }
            var n, r = document.getElementsByClassName('text-marquee__container'), a = window.requestAnimationFrame, o = window.matchMedia('(prefers-reduced-motion: reduce)').matches, c = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
            if (0 < r.length) {
                for (var d = [], l = 0; l < r.length; l++)
                    a && !o && c ? ((n = l), d.push(new e(r[n]))) : r[l].classList.add('marquee--anim-off');
                if (0 < d.length) {
                    var m = !1, u = new CustomEvent('update-marquee');
                    function h() {
                        for (var e = 0; e < d.length; e++)
                            d[e].element.dispatchEvent(u);
                    }
                    window.addEventListener('resize', function () {
                        clearTimeout(m), (m = setTimeout(h, 500));
                    }),
                        document.fonts &&
                            (document.fonts.onloadingdone = function (e) {
                                h();
                            });
                    var f = document.getElementsByClassName('text-marquee__container-control');
                    if (0 < f.length)
                        for (l = 0; l < f.length; l++)
                            a && !o && c ? t(f[l]) : f[l].classList.add('hide');
                }
            }
        };
        cloneAndSroll();
    }
};
export { marqueeSection };
